export default __webpack_public_path__ + "static/P_SearchThumb_Microphones-2ed62935bb6d384dd68149cb43df7157.webp";